"use client";

import { m, useInView } from "framer-motion";
import { useRef } from "react";
import SectionHeader from "../sectionHeader";

interface Props {
  data?: any;
}

export default function MetricsSection({ data }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
  });

  return (
    <m.section
      className={`section ${data?.darkerBackground ? "bg-neutral-200/50" : ""}`}
      ref={ref}
      transition={{ staggerChildren: 0.05, delayChildren: 0.2 }}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
    >
      <div className="container mx-auto flex flex-col items-start gap-16">
      <SectionHeader title={data?.title} headline={data?.headline} maxWidth="max-w-3xl" />
      <div className="w-full flex flex-col gap-4">
        {data?.data?.map((item: any, index: number) => {
          return (
            <div
              key={index}
              className="flex flex-col w-full"
              style={{ width: item.width ? `${item.width}%` : "100%" }}
            >
              <m.div
                className="w-full h-[5px] bg-primary"
                initial={{ width: "0%" }}
                animate={{ width: isInView ? "100%" : "0%" }}
                transition={{
                  duration: 1,
                  delay: 0.1 * index + 0.2,
                  ease: [0.83, 0, 0.17, 1],
                }}
              />
              <div className="flex justify-between items-baseline gap-4 w-full mt-4">
                <div className="font-display uppercase text-2xl sm:text-4xl lg:text-5xl shrink min-w-0" style={{ lineHeight: 1 }}>{item.title}</div>
                <div
                  key={index}
                  className="overflow-hidden shrink-0"
                  style={{ perspective: 2000 }}
                >
                  <m.div
                    variants={variantsText}
                    className="font-display uppercase text-right text-2xl sm:text-4xl lg:text-5xl whitespace-nowrap"
                    style={{ lineHeight: 1 }}
                  >
                    {item.number}
                  </m.div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      </div>
    </m.section>
  );
}

const variantsText = {
  initial: {
    y: "100%",
    opacity: 0,
    rotateX: -90,
    transformOrigin: "top",
  },
  animate: {
    y: 0,
    rotateX: 0,
    opacity: 1,
    transition: { type: "spring", duration: 0.5, delay: 1 },
  },
};
